<!-- @veltra/icons generated sha256:0dcb47175ff115a5 gen:8 source:src/svg/normal/upload.svg -->
<script setup lang="ts">
defineOptions({ name: 'Upload' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M7.501 2.914 4.085 6.33a.496.496 0 0 1-.704-.008l-.008-.008a.48.48 0 0 1 .004-.69l4.278-4.278a.48.48 0 0 1 .692 0l4.279 4.279a.48.48 0 0 1 .003.689l-.021.02a.48.48 0 0 1-.69-.004L8.5 2.914v8.089a.485.485 0 0 1-.485.497h-.011a.5.5 0 0 1-.504-.497zM2 13v-1.49a.51.51 0 0 1 .496-.51c.276 0 .504.233.504.51V13h10v-1.49a.51.51 0 0 1 .496-.51c.276 0 .504.233.504.51V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1"
    />
  </svg>
</template>
